import { useQuery } from "@tanstack/react-query";
import { pollTaskStatus } from "../../../utils/api-utils";
import type { GeneratorChangesFromMastr } from "../../../utils/backend-types";
import { getErrorText } from "../../../utils/get-error-text";
import { getChangesFromMastr } from "../utils/getChangesFromMastr";
import { getChangesFromMastrResult } from "../utils/getChangesFromMastrResult";

export function useGetPossibleGeneratorChanges(generatorId: number | null) {
  return useQuery({
    queryKey: ["getPossibleGeneratorChangesFromMastr", generatorId],
    queryFn: () => pollChangesFromMastr(generatorId),
    enabled: false
  });
}

async function pollChangesFromMastr(generatorId: number | null) {
  if (generatorId === null) {
    return [];
  }
  const changesFromMastrData = await getChangesFromMastr(generatorId);

  return new Promise<Array<GeneratorChangesFromMastr>>((resolve, reject) => {
    pollTaskStatus(
      changesFromMastrData.taskStatusUrl,
      () => {
        resolve(getChangesFromMastrResult(changesFromMastrData?.taskIds?.[0]));
      },
      (error) => {
        reject(getErrorText(error));
      }
    );
  });
}
